import React from "react";
import Select, { components } from "react-select";
import { FaChevronDown, FaTimes } from "react-icons/fa";

// Custom Single Value
const SingleValue = ({ data, ...props }) => (
  <components.SingleValue {...props}>
    <div className="flex items-center gap-2">
      {data.image && (
        <img src={data.image} alt={data.label} className="w-5 h-5" />
      )}
      <span>{data.label}</span>
    </div>
  </components.SingleValue>
);

// Dropdown arrow
const DropdownIndicator = (props) => (
  <components.DropdownIndicator {...props}>
    <FaChevronDown className="text-customGreen" />
  </components.DropdownIndicator>
);

// Multi-value remove icon
const MultiValueRemove = (props) => (
  <components.MultiValueRemove {...props}>
    <div className="bg-white rounded-full p-1 ">
      <FaTimes className="text-green-600 text-xs" />
    </div>
  </components.MultiValueRemove>
);

// Status badge helper
const StatusBadge = ({ status }) => {
  let color = "bg-gray-200 text-gray-700";
  if (status === "Info Collection & Assignment")
    color = "bg-green-100 text-green-800";
  if (status?.toLowerCase() === "sold") color = "bg-red-100 text-red-800";
  if (status?.toLowerCase() === "In Sitting")
    color = "bg-yellow-100 text-yellow-800";

  return (
    <span className={`px-2 py-1 rounded-full text-xs font-medium ${color}`}>
      {status || "Unknown"}
    </span>
  );
};

// Custom styles
const customStyles = {
  control: (base, state) => ({
    ...base,
    backgroundColor: state.isDisabled ? "#F3F4F6" : "#fff",
    borderColor: state.isFocused ? "#10B981" : "#D1D5DB",
    boxShadow: state.isFocused ? "0 0 0 1px #10B981" : "none",
    padding: "4px 8px",
    borderRadius: "0.5rem",
    minHeight: "42px",
    cursor: state.isDisabled ? "not-allowed" : "default",
    "&:hover": {
      borderColor: state.isDisabled ? "#D1D5DB" : "#10B981",
    },
  }),
  placeholder: (base) => ({
    ...base,
    color: "#9CA3AF", // placeholder color
    fontSize: "16px", // match your input font size
    fontFamily: "Inter, sans-serif", // match your input font-family
    fontWeight: 400, // optional, match input weight
  }),
  menu: (base) => ({
    ...base,
    zIndex: 49,
    borderRadius: "0.5rem",
    overflow: "hidden",
  }),
  option: (base, state) => ({
    ...base,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: state.isFocused ? "#ECFDF5" : "#fff",
    color: "#111827",
    padding: "10px 14px",
    cursor: "pointer",
    borderBottom: "1px solid #F3F4F6",
  }),
};

const CustomPropertySelect = ({
  options = [],
  value,
  onChange,
  isMulti = false,
  onInputChange,
  isClearable = true,
  placeholder = "Select property",
  className = "",
  disabled = false,
}) => {
  return (
    <Select
      className={`w-full ${className}`}
      isMulti={isMulti}
      isClearable={isClearable}
      value={value}
      isDisabled={disabled}
      onChange={onChange}
      options={options}
      onInputChange={onInputChange}
      placeholder={placeholder}
      components={{ DropdownIndicator, SingleValue, MultiValueRemove }}
      formatOptionLabel={(e, { context }) => {
        if (context === "menu") {
          return (
            <div className="flex justify-between items-start w-full">
              {/* Left Side - Details */}
              <div className="flex flex-col text-xs text-gray-600">
                <span className="text-sm font-semibold text-gray-800">
                  {e.label}
                </span>
                {e.plotNo && <span>Plot No: {e.plotNo}</span>}

                <span>Rate: {e.rate}</span>
                <span>Sourced by: {e.sourcedBy}</span>
              </div>

              {/* Right Side - Status */}
              <div className="ml-4">
                <StatusBadge status={e.status} />
              </div>
            </div>
          );
        }

        // Selected value
        return (
          <div className="flex items-center gap-2">
            <span className="font-medium">{e.label}</span>
            <span className="text-xs text-gray-500">(Plot No: {e.plotNo})</span>
          </div>
        );
      }}
      styles={customStyles}
    />
  );
};

export default CustomPropertySelect;
